module.exports = __webpack_public_path__ + "media/images/conf-c5db9a70ff417f149c7d2fb3cf8c5623.jpg";